import { frontendURL } from 'dashboard/helper/URLHelper.js';
import RawDataPage from './pages/RawDataPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const rawDataRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/raw-data'),
      name: 'raw_data_index',
      meta,
      component: RawDataPage,
    },
  ],
};

export default rawDataRoutes;
